export const SINGLE_VERSION_FIELD_GQL_TYPE = 'JiraSingleVersionPickerField';
export const MULTIPLE_VERSION_FIELD_GQL_TYPE = 'JiraMultipleVersionPickerField';
